import { useState } from "react";
import "./style.css";

export default function MuteDurationModal({ 
  conversation, 
  currentUser,
  onMute, 
  onClose, 
  isVisible 
}) {
  const [selectedDuration, setSelectedDuration] = useState('1_day');

  const muteOptions = [
    { value: '1_day', label: '1 day', icon: <span className="notranslate">📅</span> },
    { value: '1_week', label: '1 week', icon: <span className="notranslate">📆</span> },
    { value: '1_month', label: '1 month', icon: <span className="notranslate">🗓️</span> },
    { value: 'always', label: 'Always', icon: <span className="notranslate">🔇</span> }
  ];

  const handleMute = () => {
    const muteData = {
      conversationId: conversation._id,
      duration: selectedDuration,
      mutedUntil: calculateMuteUntil(selectedDuration)
    };
    
    onMute(muteData);
    onClose();
  };

  const calculateMuteUntil = (duration) => {
    const now = new Date();
    
    switch (duration) {
      case '1_day':
        return new Date(now.getTime() + 24 * 60 * 60 * 1000);
      case '1_week':
        return new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
      case '1_month':
        return new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
      case 'always':
        return null; // null means muted indefinitely
      default:
        return new Date(now.getTime() + 24 * 60 * 60 * 1000);
    }
  };

  const getConversationName = () => {
    if (conversation.type === 'group') {
      return conversation.name || 'Group Chat';
    }
    
    const otherUser = conversation.participants.find(p => p._id !== currentUser?.id);
    return otherUser ? `${otherUser.first_name} ${otherUser.last_name}` : 'Unknown User';
  };

  if (!isVisible) return null;

  return (
    <div className="mute_duration_modal_overlay" onClick={onClose}>
      <div className="mute_duration_modal" onClick={(e) => e.stopPropagation()}>
        <div className="mute_duration_header">
          <h3>Mute {getConversationName()}</h3>
          <button className="close_btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>
        
        <div className="mute_duration_content">
          <p className="mute_description">
            Choose how long you want to mute notifications for this conversation:
          </p>
          
          <div className="mute_options">
            {muteOptions.map((option) => (
              <label 
                key={option.value} 
                className={`mute_option ${selectedDuration === option.value ? 'selected' : ''}`}
              >
                <input
                  type="radio"
                  name="muteDuration"
                  value={option.value}
                  checked={selectedDuration === option.value}
                  onChange={(e) => setSelectedDuration(e.target.value)}
                />
                <div className="mute_option_content">
                  <span className="mute_option_icon">{option.icon}</span>
                  <span className="mute_option_label">{option.label}</span>
                </div>
              </label>
            ))}
          </div>
        </div>
        
        <div className="mute_duration_actions">
          <button className="cancel_btn" onClick={onClose}>
            Cancel
          </button>
          <button className="mute_btn" onClick={handleMute}>
            Mute Conversation
          </button>
        </div>
      </div>
    </div>
  );
} 